import { AuditRecord } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { StyledDropdownMenu } from 'src/components/Reusable/StandardDropdown/StandardDropdown.styles'

export const AuditsDropdownMenu = ({
  auditsList,
  onAuditSelected,
  allowClear,
}: {
  auditsList: AuditRecord[]
  onAuditSelected: (audit?: AuditRecord) => React.MouseEventHandler<HTMLElement>
  allowClear?: boolean
}): JSX.Element => (
  <Dropdown.Menu as={StyledDropdownMenu}>
    {allowClear && (
      <>
        <Dropdown.Item
          id="no-audit"
          key={''}
          eventKey={''}
          onClick={onAuditSelected()}
        >
          No Audit
        </Dropdown.Item>
      </>
    )}
    {auditsList.map((audit) => {
      const auditId = audit.getId()
      const auditName = audit.getName()
      return (
        <Dropdown.Item
          id={auditId}
          key={auditId}
          eventKey={auditId}
          onClick={onAuditSelected(audit)}
        >
          {auditName}
        </Dropdown.Item>
      )
    })}
  </Dropdown.Menu>
)
